import { computed, Injectable, signal } from '@angular/core';
import { FacetModel } from '../facet/facet.model';

@Injectable({
  providedIn: 'root',
})
export class StoryFilterService {
  readonly status = signal<'publish' | 'draft'>('publish');
  readonly selectedFacet = signal<FacetModel | null>(null);
  readonly includedLenses = signal<number | null>(null);
  readonly isPublishStatus = computed(() => this.status() === 'publish');
  readonly isDraftStatus = computed(() => this.status() === 'draft');

  setStatus = (status: 'publish' | 'draft') => {
    this.status.set(status);
  };

  setIncludedLenses = (includedLenses: number | null) => {
    this.includedLenses.set(includedLenses);
  };

  setSelectedFacet(facet: FacetModel) {
    this.selectedFacet.set(facet);
  }

  resetSelectedFacet() {
    this.selectedFacet.set(null);
  }

  resetIncludedLenses() {
    this.includedLenses.set(null);
  }
}
